const s = /* @__NO_SIDE_EFFECTS__ */ (o) => o * 1e3, c = /* @__NO_SIDE_EFFECTS__ */ (o) => o / 1e3;
export {
  c as millisecondsToSeconds,
  s as secondsToMilliseconds
};
